import React from 'react';
import { useTranslation } from 'react-i18next';
import { BdsIcon } from '@/core/constants/webComponents';
import './UnsavedChangesAlert.scss';

interface UnsavedChangesAlertProps {
  onContinueWithoutSaving: () => void;
  onSaveFilter: () => void;
}

export const UnsavedChangesAlert: React.FC<UnsavedChangesAlertProps> = ({
  onContinueWithoutSaving,
  onSaveFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="unsaved-alert-overlay">
      <dialog
        className="unsaved-alert"
        aria-modal="true"
        aria-labelledby="unsaved-alert-title"
        open
      >
        <div className="unsaved-alert__header">
          <BdsIcon name="warning" size="small" />
          <span id="unsaved-alert-title" className="unsaved-alert__title">
            {t('globalFilter.unsavedAlert.title', 'Que tal salvar o filtro criado?')}
          </span>
        </div>
        <p className="unsaved-alert__body">
          {t(
            'globalFilter.unsavedAlert.body',
            'Ao alterar a aba sem salvar, você perderá os filtros que foram aplicados.',
          )}
        </p>
        <div className="unsaved-alert__actions">
          <button type="button" className="btn-text" onClick={onContinueWithoutSaving}>
            {t('globalFilter.unsavedAlert.continueWithoutSaving', 'Continuar sem salvar')}
          </button>
          <button type="button" className="unsaved-alert__btn-primary" onClick={onSaveFilter}>
            {t('globalFilter.unsavedAlert.saveFilter', 'Salvar filtro')}
          </button>
        </div>
      </dialog>
    </div>
  );
};
